/**
 * Database Tab Content Components
 *
 * Content components for database-related tabs.
 */

import { SERVICE_CONFIG } from '@/app/data-catalog/_common/constants'
import { MetaDataTable } from '@/app/data-catalog/metadata-table'
import { SchemaTable } from '@/app/data-catalog/schema-table'
import { TableList } from '@/app/data-catalog/table-page'

// =============================================================================
// DATABASE TAB CONTENT COMPONENTS
// =============================================================================

/**
 * Content for database tabs
 */
export const DatabaseSchemaTabContent = ({
  databaseName,
  assetType,
}: Readonly<{ databaseName: string; assetType?: string }>) => (
  <SchemaTable
    assetType={assetType}
    service_name={SERVICE_CONFIG.SERVICE_NAME}
    database_name={databaseName}
  />
)

/**
 * Content for database table tabs
 */
export const DatabaseTableTabContent = ({
  databaseName,
  schemaName,
  assetType,
}: Readonly<{
  databaseName: string
  schemaName: string
  assetType?: string
}>) => (
  <TableList
    service_name={SERVICE_CONFIG.SERVICE_NAME}
    database_name={databaseName}
    schema_name={schemaName}
    assetType={assetType}
  />
)

/**
 * Content for database metadata tabs
 */
export const DatabaseMetadataTabContent = ({
  databaseName,
  schemaName,
  tableName,
  assetType,
}: Readonly<{
  databaseName: string
  schemaName: string
  tableName: string
  assetType?: string
}>) => (
  <MetaDataTable
    service_name={SERVICE_CONFIG.SERVICE_NAME}
    database_name={SERVICE_CONFIG.DATABASE_NAME}
    schema_name={schemaName}
    table_name={tableName}
    assetType={assetType}
  />
)
